import { proxy } from 'valtio'

const subwalletStore = proxy({
  search: null
})

export default subwalletStore
